
// データ管理

// vue
import Vue from 'vue';
// プリロードクラス
import preload from '../../caracol_es2015.1.0/util/preload';

export default new Vue({
    // データ
    data: {
        episode_list: []
    },
    methods: {
        /**
         * プロパティ名を指定してデータを取得
         * @param {String} name
         * @return {Objecct}
         */
        get_data(name) {
            return this.$data[name];
        },
        /**
         * プロパティ名を指定して書き換え
         * @param {String} name
         * @param {*} val
         */
        set_data(name, val) {
            Vue.set(this, name, val);
        },
        /**
         * IDからエピソードを取得
         */
        get_episode_from_story_id(story, id) {
            const list = this.episode_list[story];
            const length = list.length;
            for (let i = 0; i < length; i += 1) {
                if (list[i].id === id) {
                    return list[i];
                }
            }
            return null;
        },
        /**
         * 最新のエピソード
         */
        get_last_episode_from_story(story) {
            const length = this.episode_list[story].length;
            return this.episode_list[story][length - 1];
        },
        /**
         * 画像読み込み
         */
        load_images(urls) {
            this.$emit('LOAD_IMAGES_READY');

            // 画像を読み終わったら .2s後に表示
            preload(urls)
            .done(() => {
                setTimeout(() => {
                    // 読み込み完了通知
                    this.$emit('LOAD_IMAGES_COMPLETE');
                }, 200);
            });
        }
    }
});



// WEBPACK FOOTER //
// ./js/page/story/episode_data.js